import {
  removeNullAttributes,
  queryStringFromObject,
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getHMplusVersionList(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { sortOrder, sortBy } = { ...queryParams };
  delete queryParams.sortOrder;
  delete queryParams.sortBy;

  const sortQuery =
    sortOrder && sortBy
      ? `&sort=${
          sortBy === "uploadedDate" ? "uploadedDateInMillis" : sortBy
        }:${sortOrder}`
      : "";

  const queryObject = removeNullAttributes(queryParams);
  const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/version-files/analyzers/hmplus?${query}${sortQuery}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}
function uploadHMplusVersion(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      // "Content-Type": "multipart/form-data",
      ...authHeader(),
    },
    body: formData,
  };

  const endPoint = `/api/admin/v1/version-files/analyzers/hmplus`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}
function deleteHMplusVersion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/version-files/analyzers/hmplus/${queryParams}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}
function showhmplusVersion(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const { version } = queryParams;
  const endPoint = `/api/admin/v1/version-files/analyzers/hmplus/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const hmplusVersionListService = {
  getHMplusVersionList,
  uploadHMplusVersion,
  deleteHMplusVersion,
  showhmplusVersion,
};
